import "./hero-inner-gradient.scss";
